import React, { useEffect } from "react";
import { Box, Grid, Typography } from "@mui/material";
import GenericList from "./GenericList";
import ButtonComponent from "./ButtonComponent";
import { COLORS } from "../config/theme";
import { obtenerHistorialRequisito } from "../services/historial.service";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { obtenerDocumento } from "../services/uploadFile.service";
import moment from "moment-timezone";

export default function RequisitoListaHistorico({
  setIsVisibleModal,
  setReload,
  reload,
  requisito,
}) {
  const abrirDocumento = async (key) => {
    try {
      const response = await obtenerDocumento(key);

      if (response) {
        const signedUrl = response.url;
        const resultURL = signedUrl.split("?");

        window.open(resultURL[0], "_blank");
      } else {
        console.error("Error obteniendo documento");
        // TODO: Mostrar mensaje en pantalla
      }
    } catch (error) {
      console.error("Failed to get signed URL", error);
    }
  };

  const columnas = [
    { title: "ACCIÓN", field: "motivo", width: "50px" },
    {
      title: "FECHA",
      field: "fecha_modificacion",
      width: "50px",
      defaultSort: "asc", // cronológico: del más antiguo al más reciente
      render: (row) =>
        row.mov_respuesta_fecha
          ? moment(row.fecha_modificacion).utcOffset(-180).format("DD/MM/YYYY HH:mm") // UTC -3
          : "--/--/----",
    },
    { title: "PROFESIONAL", field: "mov_respuesta_usu_nombre", width: "30px" },
    // { title: "RESPUESTA", field: "mov_respuesta_obs", width: '200px' },
    {
      title: "RESPUESTA",
      field: "mov_respuesta_file_url",
      render: (row) =>
        row.respuesta_file_url ? (
          <div
            onClick={() => abrirDocumento(row.respuesta_file_url)}
            style={{
              textDecoration: "none",
              color: "inherit",
              cursor: "pointer",
              display: "flex",
              justifyContent: "left",
              alignItems: "center",
              width: "100%",
              height: "100%",
            }}
          >
            <DescriptionOutlinedIcon style={{ fontSize: 30 }} />
            <Typography variant="body2">{row.respuesta_file_nombre}</Typography>
          </div>
        ) : (
          <div
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {row.mov_respuesta_obs}
          </div>
        ),
      width: "40px",
    },
    { title: "REVISOR", field: "mov_revision_us_nombre", width: "30px" },
    {
      title: "MOTIVO RECHAZO",
      field: "mov_revision_obs",
      width: "150px",
      render: (row) =>
        row.mov_revision_obs && (
          <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
            {row.mov_revision_obs}
          </div>
        ),
    },
    {
      title: "ARCHIVO RECHAZO",
      field: "revision_file_url",
      render: (row) =>
        row.revision_file_url && (
          <div
            onClick={() => abrirDocumento(row.revision_file_url)}
            style={{
              textDecoration: "none",
              color: "inherit",
              cursor: "pointer",
              display: "flex",
              justifyContent: "left",
              alignItems: "center",
              width: "100%",
              height: "100%",
            }}
          >
            <DescriptionOutlinedIcon style={{ fontSize: 30 }} />
            <Typography variant="body2">{row.revision_file_nombre}</Typography>
          </div>
        ),
      width: "60px",
    },
  ];

  // Trae una página del historial directamente del backend. Se pasa como
  // `data` (función) a GenericList/MaterialTable, que la vuelve a invocar
  // solos con la página/orden que corresponda cada vez que el usuario
  // cambia de página, de tamaño de página u ordena una columna — antes
  // esos cambios sólo actualizaban estado local y nunca volvían a pedir
  // datos al servidor, por lo que jamás se veía más allá de los primeros
  // 10 registros del historial.
  const fetchHistorial = async (query) => {
    const { page, pageSize, orderByCollection } = query;
    const orderByField = orderByCollection?.[0]?.orderByField || "fecha_modificacion";
    const orderByDirection = orderByCollection?.[0]?.orderDirection || "asc";

    try {
      const response = await obtenerHistorialRequisito(
        requisito.id_mov,
        pageSize,
        page + 1, // material-table pagina desde 0, el backend desde 1
        orderByField,
        orderByDirection
      );
      const { data, totalCount } = response.data;
      return { data: data || [], page, totalCount: totalCount || 0 };
    } catch (error) {
      console.error("Error obteniendo historial", error);
      return { data: [], page, totalCount: 0 };
    }
  };

  const onClose = () => {
    setIsVisibleModal(false);
  };

  useEffect(() => {
    const errorHandler = (e) => {
      if (
        e.message.includes(
          "ResizeObserver loop completed with undelivered notifications" ||
            "ResizeObserver loop limit exceeded"
        )
      ) {
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.style.display = "none";
        }
      }
    };
    window.addEventListener("error", errorHandler);
    return () => {
      window.removeEventListener("error", errorHandler);
    };
  });

  return (
    <>
      <Grid item xs={12}>
        <GenericList
          key={requisito?.id_mov}
          columns={columnas}
          data={fetchHistorial}
          actions={[]}
          itemsToShow={5}
          hideSearch={true}
          hideFilter={true}
          addDisabled={true}
          onPageChange={() => {}}
          onPageSizeChange={() => {}}
          onOrderChange={() => {}}
        />
      </Grid>

      <Grid item xs={12}>
        <Box display="flex" justifyContent="flex-end">
          <ButtonComponent
            name="Cerrar"
            toAction={onClose}
            color={COLORS.DANGER}
          />
        </Box>
      </Grid>
    </>
  );
}
